import { useTranslation } from 'react-i18next'

import AddIcon from '@mui/icons-material/AddRounded'

import { useModal } from '@hooks/app/modal.hook'

import { GuardProjectList } from '../ProjectList'

import { AddProjectButton, AddProjectIcon, AddProjectLabel, Container } from './SideBarMenu.styled'

export const SideBarMenu = (): JSX.Element => {
  const { t } = useTranslation()

  const { displayModal } = useModal()

  return (
    <Container>
      <AddProjectButton onClick={() => displayModal('add_project')}>
        <AddProjectIcon>
          <AddIcon />
        </AddProjectIcon>
        <AddProjectLabel>{t('modules_main_components_SideBarMenu_label_add_project')}</AddProjectLabel>
      </AddProjectButton>

      <GuardProjectList />
    </Container>
  )
}
